import React, { useEffect } from 'react';
import PresaleHero from '../components/landing/PresaleHero';
import PresaleDetails from '../components/landing/PresaleDetails';

const Presale = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="presale-page">
      <PresaleHero />
      <PresaleDetails />
    </div>
  );
};

export default Presale;
